import { isEmpty } from "lodash";
import { toJSON } from "../../utils";
export class ERC721Metadata {
    constructor(params) {
        var _a;
        this.name = params.name;
        this.image = params.image;
        this.description = params.description || "";
        if (params.image_data)
            this.image_data = params.image_data;
        if (params.external_url)
            this.external_url = params.external_url;
        if (params.background_color)
            this.background_color = params.background_color;
        if (params.animation_url)
            this.animation_url = params.animation_url;
        if (params.youtube_url)
            this.youtube_url = params.youtube_url;
        this.attributes =
            ((_a = params.attributes) === null || _a === void 0 ? void 0 : _a.filter((attribute) => attribute.trait_type && (attribute.value || attribute.value === 0))) || [];
    }
    get json() {
        return toJSON(this);
    }
    updateAttribute(attribute) {
        if (!(attribute.trait_type && (attribute.value || attribute.value === 0)))
            return;
        const i = this.attributes.findIndex((a) => a.trait_type == attribute.trait_type);
        i == -1
            ? this.attributes.push(attribute)
            : (this.attributes[i] = attribute);
    }
    updateMultipleAttributes(attributes) {
        for (const attribute of attributes) {
            this.updateAttribute(attribute);
        }
    }
    update(update) {
        if (!update || isEmpty(update))
            return this;
        if (update.name)
            this.name = update.name;
        if (update.description)
            this.description = update.description;
        if (update.image)
            this.image = update.image;
        if (update.image_data)
            this.image_data = update.image_data;
        if (update.external_url)
            this.external_url = update.external_url;
        if (update.background_color)
            this.background_color = update.background_color;
        if (update.animation_url)
            this.animation_url = update.animation_url;
        if (update.youtube_url)
            this.youtube_url = update.youtube_url;
        if (update.attributes && !isEmpty(update.attributes))
            this.updateMultipleAttributes(update.attributes);
        return this;
    }
}
